import React from "react";
import AutoPlaySilentVideo from "../videoSPI"; // Importe o componente

const Gif = () => {
  return (
    <div>
      <AutoPlaySilentVideo />
    </div>
  );
};

export default Gif;